import { readActiveMissionPackId } from '../content-director-store'
import { readMissionPackStoreByPackId } from '../../lesson-content/lesson-content-store'

function getActiveMissionPack() {
  const activeMissionPackId = readActiveMissionPackId()
  return readMissionPackStoreByPackId(activeMissionPackId)
}

export { getActiveMissionPack }